document.addEventListener('DOMContentLoaded', function() {
  const initSingleJournalLayout = () => {
    if (typeof gsap === 'undefined') {
      setTimeout(initSingleJournalLayout, 50);
      return;
    }

    document.querySelectorAll('.journal-section-outer-wrapper').forEach(wrapper => {
      const textSlides = wrapper.querySelectorAll('.journal-text-item');
      const imgSlides = wrapper.querySelectorAll('.journal-img-slide');
      const dateDisplay = wrapper.querySelector('.journal-active-date');
      const nextBtn = wrapper.querySelector('.next-j-btn');
      const prevBtn = wrapper.querySelector('.prev-j-btn');

      if (textSlides.length === 0) return;

      let currentIndex = 0;
      let animating = false;

      const updateDateString = (idx) => {
        if (!dateDisplay) return;
        const targetDate = textSlides[idx].getAttribute('data-date');
        if (targetDate) dateDisplay.textContent = targetDate;
      };

      updateDateString(currentIndex);

      if (textSlides.length <= 1) {
        if (nextBtn && prevBtn) {
          wrapper.querySelector('.journal-arrow-nav-buttons').style.display = 'none';
        }
        return;
      }

      function transitionToPost(targetIndex, direction) {
        if (animating || targetIndex === currentIndex) return;
        animating = true;

        const curText = textSlides[currentIndex];
        const nextText = textSlides[targetIndex];
        const curImg = imgSlides[currentIndex];
        const nextImg = imgSlides[targetIndex];

        const pushValue = direction === 'next' ? 25 : -25;
        const tl = gsap.timeline({
          onComplete: () => {
            curText.classList.remove('active-slide');
            curImg.classList.remove('active-slide');
            currentIndex = targetIndex;
            animating = false;
          }
        });

        nextText.classList.add('active-slide');
        nextImg.classList.add('active-slide');
        updateDateString(targetIndex);

        tl.to(curText, { opacity: 0, y: -pushValue, duration: 0.25, ease: "power2.in" }, 0)
          .fromTo(nextText, 
            { opacity: 0, y: pushValue },
            { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }, 0.15
          )
          .to(curImg, { opacity: 0, duration: 0.35, ease: "power2.inOut" }, 0)
          .fromTo(nextImg,
            { opacity: 0 },
            { opacity: 1, duration: 0.45, ease: "power2.out" }, 0.05
          );
      }

      nextBtn.addEventListener('click', () => {
        const nextIdx = (currentIndex + 1) % textSlides.length;
        transitionToPost(nextIdx, 'next');
      });

      prevBtn.addEventListener('click', () => {
        const prevIdx = (currentIndex - 1 + textSlides.length) % textSlides.length;
        transitionToPost(prevIdx, 'prev');
      });
    });
  };

  initSingleJournalLayout();
});